<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="'75%'"
      :height="730"
      :title="title"
      @hidden="popupHidden"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 transaction-list">
        <GcDataGrid
          :grouping="false"
          :export="false"
          :summary="false"
          :paging="true"
          :dataSourceConfig="dataSourceConfig"
          :columns="columns"
          :gridToolbar="gridToolbar"
          :padColumn="false"
          :id="'gc-popup-search-for-item'"
          :auto-expand-all="false"
          :gridOptions="gridOptions"
          :isLocalDataSource="false"
          :ref="'gc-popup-search-for-item'"
          :dxScrolling="'standard'"
          :isEditableGrid="false"
          :key="1"
          v-if="productDataSource"
          :onRowDblClick="rowDblClickCallback"
          :gridHeightOverWrite="630"
        />
      </div>

      <div class="footer edit-product-item-popup-footer">
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="popupHidden"
          v-if="productDataSource"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
// import ApiService from "../_services/api/api.service";
import BaseViewMixin from "../v1/_mixins/base.view";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    productListQuery: {
      type: Object,
      default: () => {},
    },
    productListColumns: {
      type: Array,
      default: undefined,
    },
    productListItems: {
      type: Array,
      default: undefined,
    },
    title: {
      type: String,
      default: "Search Item",
    },
    gridOptions: {
      type: Object,
      default: () => {
        return {
          options: {
            pageSize: 50,
          },
        };
      },
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      productDataSource: undefined,
      productColumns: [],
    };
  },
  async created() {
    if (this.setLoading) this.setLoading(true);
    this.updateDataSource();
  },
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
    gridToolbar() {
      return {
        search: true,
        columnChooser: false,
        export: false,
        openFilter: false,
        header: false,
      };
    },
    dataSourceConfig() {
      if (!this.productListItems) {
        return this.productDataSource;
      } else
        return {
          localDataList: true,
          items: this.productListItems,
          serverPaging: true,
          allowGrouping: false,
        };
    },
    columns() {
      return this.productListColumns
        ? this.productListColumns
        : [
            {
              screenField: "Comments",
              label: "Item",
              dataField: "Code",
            },
            {
              screenField: "Comments",
              label: "Item Description",
              dataField: "Description1",
            },
          ];
    },
  },
  watch: {},
  methods: {
    searchForProductItem() {
      this.searchForItem.visible = false;
    },
    async updateDataSource() {
      if (this.productListItems) {
        this.productDataSource = this.productListItems;
      } else {
        if (!this.productListQuery) {
          this.productDataSource = {
            endpoint: "ProductList",
            filter: [["Inactive", "=", "N"]],
            serverPaging: true,
            allowGrouping: false,
          };
        } else {
          this.productDataSource = this.productListQuery;
        }
      }

      if (this.setLoading) this.setLoading(false);
    },
    popupHidden() {
      this.callBack(null, false);
    },
    rowDblClickCallback(e) {
      if (this.productListQuery) this.callBack(e.data, this.productDataSource);
      else this.callBack(e.data, true);
    },
  },
};
</script>
